import React from 'react'
import './style.scss'
import $ from 'jquery'

export const handlePopupCheckInfo = (status) => {
    if(status)
    {
        $(".popup-checkinfo")
        // .css("display", "flex")
        // .hide()
        .fadeIn();
    }else
    {
        $(".popup-checkinfo").fadeOut();
    }
}

function PopupCheckInfo({ data, onClose, onSubmit, onSkip }) {

    return (
        <div className="popup-checkinfo">
            <div className="overlay"></div>
            <div className="group-info">
                <h2>ข้อมูลไม่ตรงกับระบบ</h2>
                <div className="dgroup">
                    <p><span className="title">เลขประจำตัวประชาชน </span><span>:</span><span className="value">{!!data && data.Identification_Number}</span></p>
                    <p><span className="title">ชื่อ-นามสกุล(ไทย) </span><span>:</span><span className="value">{!!data && data.PrefixTH} {!!data && data.NameTH} {!!data && data.LastNameTH}</span></p>
                    <p><span className="title">ชื่อ-นามสกุล(อังกฤษ) </span><span>:</span><span className="value">{!!data && data.PrefixEN} {!!data && data.NameEN} {!!data && data.LastNameEN}</span></p>
                    <p><span className="title">วันเดือนปีเกิด(พ.ศ.) </span><span>:</span><span className="value">{!!data && data.BirthdayTH}</span></p>
                    <p><span className="title">วันเดือนปีเกิด(ค.ศ.) </span><span>:</span><span className="value">{!!data && data.BirthdayEN}</span></p>
                </div>
                <p className='remark'>*ข้อมูลไม่ตรงกับระบบ กรุณาลองอีกครั้ง</p>
                <div className="btn-group">
                    <button onClick={onClose}>ลองอีกครั้ง</button>
                    {/* <button onClick={() => onSubmit(data)}>ยืนยัน</button> */}
                    {/* <button className='skip-btn' onClick={onSkip}>ข้าม</button> */}
                </div>
            </div>
        </div>
    )
}

export default PopupCheckInfo